import { useState } from 'react'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { ConversationProgressStubStyled } from './styles/ConversationStreamStyled'

export const THINKING_PHRASES = [
  messages.thinkingDefault,
  messages.thinkingUnderstanding,
  messages.thinkingSearching,
  messages.thinkingRanking,
  messages.thinkingPreparing,
]

let phraseCursor = 0
const nextPhrase = () => {
  const phrase = THINKING_PHRASES[phraseCursor % THINKING_PHRASES.length]
  phraseCursor += 1
  return phrase
}

interface IConversationThinkingIndicatorProps {
  label?: Nullable<string>
}

export const ConversationThinkingIndicator = ({
  label = null,
}: IConversationThinkingIndicatorProps) => {
  const intl = useProcurifyIntl()
  const [phrase] = useState(nextPhrase)

  return (
    <ConversationProgressStubStyled
      role='status'
      aria-label={intl.formatMessage(messages.typing)}
    >
      {label ?? intl.formatMessage(phrase)}
    </ConversationProgressStubStyled>
  )
}
